import React from "react";
import PropTypes from "prop-types";
import { Level, Field, Button, Control } from "rbx";

function FilterButtons({
  handleClose,
  handleCancel,
  handleReset,
  errors = []
}) {
  return (
    <Level>
      <Level.Item align="left">
        <Field kind="group">
          <Control>
            <Button
              color="primary"
              disabled={errors.length}
              onClick={handleClose}
            >
              OK
            </Button>
          </Control>
          <Control>
            <Button onClick={handleCancel}>Cancel</Button>
          </Control>
        </Field>
      </Level.Item>
      <Level.Item align="right">
        <Field>
          <Control>
            <Button onClick={handleReset}>Reset</Button>
          </Control>
        </Field>
      </Level.Item>
    </Level>
  );
}
FilterButtons.propTypes = {
  errors: PropTypes.array,
  handleClose: PropTypes.func,
  handleReset: PropTypes.func,
  handleCancel: PropTypes.func
};
export default FilterButtons;
